import { ErrorParser } from "../ErrorParser";
import { isObject } from "lodash-es";

/**
 * Ej: 'Processed questions cannot be updated'
 */
export class NoModificarProcesadoParser implements ErrorParser {
    public puedeLeerError(error: string): boolean {
        return !isObject(error) && error.includes("Processed") && error.includes("cannot be updated");
    }

    public traducir(_error: string): string {
        return "Los cuestionarios procesados no se pueden modificar.";
    }
}
